'use strict';

angular.module('mobile-apps').controller('AppstoreConnectorModalController', [
	'$scope',
	'EventTracker',
	'ModalData',
	'MobileApps',
	'AppstoreIntegration',
	'Utilities',
	'$modalInstance',
	'$window',
	'$timeout',
	function (
		$scope,
		EventTracker,
		ModalData,
		MobileApps,
		AppstoreIntegration,
		Utilities,
		$modalInstance,
		$window,
		$timeout
	) {

		$scope.data = {
			loadingData: undefined,
			mobileApp: {},
			androidIntegration: undefined,
			iosIntegration: undefined
		};


		/**
		 * Sets the loading status and makes sure digest cycles runs
		 * to update view accordingly
		 * @param loadingStatus The status to set
         */
		function setLoading(loadingStatus) {
			$timeout(function() {
				$scope.data.loadingData = loadingStatus;
			});
		}


		/**
		 * Downloads the listings from the app store
     	 */
		$scope.downloadListing = function(storeType) {

			var sendData = {
				mobileAppId: ModalData.mobileApp._id,
				storeType: storeType
			};

			setLoading(storeType + 'Download');

			AppstoreIntegration.importData(sendData).$promise
				.then(
					function(data) {
						setLoading();

						var storeName = 'Apple Appstore';
						if (storeType === 'android') {
							storeName = 'Android Playstore';
						}

						return Utilities.showMessage('Success', 'Successfully downloaded listings from ' + storeName + ' into group "App Store"!', 'success');
					}
				)
				.then(
				  function(data) {
					  // Refresh the data that the user can see the correct counts
					  $window.location.reload();

					  $modalInstance.close({success: true});
				  }
				)
				.catch(
					function(error) {
						setLoading();
						Utilities.showMessageErrorResponse(error);
					}
				);
		};


		/**
		 * Downloads the listings from the app store
		 */
		$scope.uploadTranslations = function(storeType) {

			var sendData = {
				mobileAppId: ModalData.mobileApp._id,
				storeType: storeType
			};

			setLoading(storeType + 'Upload');

			AppstoreIntegration.exportData(sendData).$promise
				.then(
					function(data) {
						setLoading();

						var storeName = 'Apple Appstore';
						if (storeType === 'android') {
							storeName = 'Android Playstore';
						}

						if (!data.errors) {
							// Incomplete requests (because error should always be there but then an empty array)
							// Maybe lost connection to ruby service
							Utilities.showMessage('Problems', 'It seems like there was a problem with the request. Please make sure to wait at least 1 minute and then try again.', 'error');
						} else if (data.errors.length) {
							// There were problems
							Utilities.showMessage('Problems', 'We encountered the following errors uploading the translations:<br /> - ' + data.errors.join('<br /> - '), 'error');
							// Everything worked except of the problems in errors
							// so still return as success that it refreshes the page
							// an so displays the correct counts.
							$modalInstance.close({success: true});
						} else {
							// Success
							Utilities.showMessage('Success', 'Successfully uploaded translations to ' + storeName + '!', 'success');
							$modalInstance.close({success: true});
						}

					}
				)
				.catch(
					function(error) {
						setLoading();
						Utilities.showMessageErrorResponse(error);
					}
				);
		};


		/**
		 * Close modal
		 */
		$scope.close = function() {
			$modalInstance.dismiss();
		};


		/**
		 * Loads the needed data
		 */
		function init() {
			MobileApps.get({mobileAppId: ModalData.mobileApp._id}).$promise
				.then(
					function(mobileApp) {
						$scope.data.mobileApp = mobileApp;
						if (mobileApp.integrations) {
							if (mobileApp.integrations.hasOwnProperty('iosAppstore') && mobileApp.integrations.iosAppstore.length) {
								$scope.data.iosIntegration = mobileApp.integrations.iosAppstore[0].data;
							}
							if (mobileApp.integrations.hasOwnProperty('androidAppstore') && mobileApp.integrations.androidAppstore.length) {
								$scope.data.androidIntegration = mobileApp.integrations.androidAppstore[0].data;
							}
						}
					}
				)
				.catch(
					function(error) {
						Utilities.showMessageErrorResponse(error);
					}
				);
		}

		init();

	}
]);

